import TotalCard from 'Pages/reports/[submodules]/employees/components/TotalCard/TotalCard';
import { TotalCourseDetailsWrapper } from './TotalCourseDetails.styled';
import type { CourseEmployeesReportTotalsI } from 'types';
import useTranslation from 'Hooks/useTranslation';
import SchoolIcon from '@mui/icons-material/School';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { buildTime } from 'Pages/reports/utils/buildTime';

interface Props {
  totals: CourseEmployeesReportTotalsI;
}

const TotalCourseDetails = ({ totals }: Props) => {
  const { t2 } = useTranslation('course_employees_report');
  const trainingHours = buildTime(totals?.trainingHours?.split(':')?.[0], totals?.trainingHours?.split(':')?.[1], t2);

  return (
    <TotalCourseDetailsWrapper>
      <TotalCard
        value={totals.enrolledEmployees}
        label={t2('enrolled_employees')}
        icon={<SchoolIcon />}
        description={t2('enrolled_employees_description')}
      />
      <TotalCard
        value={totals.approvedEmployees}
        label={t2('approved_employees')}
        icon={<AssignmentTurnedInIcon />}
        description={t2('approved_employees_description')}
      />
      <TotalCard
        value={totals.pendingEmployees}
        label={t2('pending_employees')}
        icon={<PendingActionsIcon />}
        description={t2('pending_employees_description')}
      />
      <TotalCard
        value={`${totals.progressPercentage}%`}
        label={t2('progress_percentage')}
        icon={<QueryBuilderIcon />}
        description={t2('progress_percentage_description')}
        fillAnimation={true}
        fillPercentage={totals.progressPercentage}
      />
      <TotalCard
        value={trainingHours}
        label={t2('total_training_hours')}
        icon={<TrendingUpIcon />}
        description={t2('total_training_hours_description')}
      />
    </TotalCourseDetailsWrapper>
  );
};

export default TotalCourseDetails;
